import { FireCMSTranslations } from "@firecms/core";

/** FireCMS chrome — resmi tr paketi yok; en.ts ile birebir key. */
export const firecmsTr: FireCMSTranslations = {
    save: "Kaydet",
    create: "Oluştur",
    create_copy: "Kopya oluştur",
    save_and_close: "Kaydet ve kapat",
    create_copy_and_close: "Kopya oluştur ve kapat",
    create_and_close: "Oluştur ve kapat",
    discard: "Vazgeç",
    clear: "Temizle",
    cancel: "Vazgeç",

    edit: "Düzenle",
    copy: "Kopyala",
    delete: "Sil",

    delete_confirmation_title: "Silinsin mi?",
    delete_confirmation_body: "Bu kayıt silinecek. Emin misiniz?",
    delete_multiple_confirmation_body: "Seçilen kayıtlar silinecek. Emin misiniz?",

    unsaved_changes_title: "Kaydedilmemiş değişiklikler",
    unsaved_changes_body: "Kaydedilmemiş değişiklikler var. Vazgeçmek istiyor musunuz?",
    discard_changes: "Değişiklikleri at",
    keep_editing: "Düzenlemeye devam et",

    search: "Ara",
    find_by_id: "ID ile bul",
    find_entity_by_id: "Kaydı ID ile bul",
    filter: "Filtrele",
    filters: "Filtreler",
    clear_filter: "Filtreyi temizle",
    clear_filter_sort: "Filtre/sıralamayı temizle",
    clear_sort: "Sıralamayı temizle",
    no_items: "Kayıt yok",
    no_entries_found: "Kayıt bulunamadı",
    all_entries_loaded: "Tüm {{count}} kayıt yüklendi",
    create_your_first_entry: "İlk kaydı oluşturun",
    no_results_filter_sort: "Uygulanan filtre/sıralama ile sonuç yok",
    add: "Ekle",
    remove: "Kaldır",
    multiple_entities: "Birden fazla kayıt",
    unsaved_changes: "Bu {{collectionName}} içinde kaydedilmemiş değişiklikler var.",
    so_empty: "Henüz kayıt yok…",
    no_results: "Uygulanan filtre/sıralama ile sonuç yok",
    refresh_data: "Veriyi yenile",
    dark_mode: "Koyu",
    light_mode: "Açık",
    system_mode: "Sistem",
    ok: "Sil",
    save_collection_config: "Koleksiyon yapısını kaydet",
    search_for_more_icons: "Daha fazla ikon ara…",
    ai_modified: "AI ile değişti",
    size_label: "Boyut",
    group_by: "Grupla",
    initialize_kanban_order: "Kanban sırasını başlat",
    copy_id: "ID kopyala",
    add_specific: "{{name}} ekle",
    select_specific: "{{name}} seç",
    select_from: "{{name}} içinden seç",
    done: "Tamam",
    log_out: "Çıkış",
    license_needed: "Lisans gerekli",
    license_description: "FireCMS PRO için geçerli lisans gerekir. Bilgi için {{email}} adresine yazın.",
    column_cannot_be_edited: "Bu sütun doğrudan düzenlenemez",
    close: "Kapat",
    unsaved_local_changes: "Kaydedilmemiş yerel değişiklikler",
    unsaved_local_changes_description: "Bu belge yerelde düzenlendi ve kaydedilmedi. Uygulamazsanız bu değişiklikler kaybolur.",
    preview_changes: "Değişiklikleri önizle",
    apply_changes: "Değişiklikleri uygula",
    discard_local_changes: "Yerel değişiklikleri at",
    preview_local_changes: "Yerel değişiklikleri önizle",
    preview_local_changes_description: "Forma uygulanacak yerel değişiklikler bunlar.",
    type: "Tür",
    string: "metin",
    number: "sayı",
    boolean: "mantıksal",
    date: "tarih",
    map: "nesne",
    array: "dizi",
    arrays_of_arrays_not_supported: "İç içe diziler desteklenmiyor.",
    data_type_not_supported: "{{dataType}} veri türü henüz desteklenmiyor",
    passkey_error_unsupported: "Cihazınız veya tarayıcınız geçiş anahtarlarını desteklemiyor.",

    admin: "Yönetici",
    home: "Anasayfa",
    this_form_has_errors: "Bu formda hatalar var",
    error_loading_navigation: "Menü yüklenirken hata",
    error_loading_auth: "Kimlik doğrulama yüklenirken hata",
    this_form_has_been_modified: "Bu form değiştirildi",
    current_form_in_sync: "Form veritabanı ile senkron",
    open_in_console: "Konsolda aç",
    collection_does_not_exist: "Belirtilen koleksiyon yok. Konsolu kontrol edin",
    unexpected_value: "Beklenmeyen değer",
    unexpected_value_click_to_edit: "Beklenmeyen değer. Düzenlemek için tıklayın",
    unexpected_reference_value: "Beklenmeyen referans. Düzenlemek için tıklayın",
    copy_url_to_clipboard: "URL'yi panoya kopyala",
    open_image_in_new_tab: "Görseli yeni sekmede aç",
    reference_not_set: "Referans ayarlanmadı",
    reference_does_not_exist: "Referans yok",
    entity_not_found: "Kayıt bulunamadı",
    file_not_found: "Dosya bulunamadı",
    unsaved_changes_in_entity: "Bu kayıtta kaydedilmemiş değişiklikler var.",
    delete_this_role: "Bu rolü sil",
    no_roles_yet: "Henüz rol yok.",
    create_default_roles: "Varsayılan rolleri oluştur",
    delete_role_confirmation: "Bu rolü silmek istediğinize emin misiniz?",
    delete_this_user: "Bu kullanıcıyı sil",
    no_users_yet: "Henüz kullanıcı yok",
    add_logged_user_as_admin: "Oturum açmış kullanıcıyı yönetici yap",
    add_current_user_as_admin: "Geçerli kullanıcıyı yönetici yap",
    create_default_roles_and_add_admin: "Varsayılan rolleri oluştur ve geçerli kullanıcıyı yönetici yap",
    delete_user_confirmation: "Bu kullanıcıyı silmek istediğinize emin misiniz?",
    create_your_users_and_roles: "Kullanıcı ve rollerinizi oluşturun",
    no_users_or_roles_defined: "Kullanıcı veya rol tanımlı değil. Varsayılan roller oluşturup geçerli kullanıcıyı yönetici yapabilirsiniz.",
    save_before_changing_schema: "Şemayı değiştirmeden önce belgeyi kaydedin",
    edit_schema_for_this_form: "Bu formun şemasını düzenle",
    no_permissions_to_edit_collection: "Bu koleksiyonu düzenleme izniniz yok",
    browser_does_not_support_audio: "Tarayıcınız ses öğesini desteklemiyor.",
    user_not_found: "Kullanıcı bulunamadı: {{value}}",

    delete_selected: "Sil",
    cannot_delete_selected: "Silinemeyen en az bir kayıt seçtiniz",

    add_entry: "Ekle",
    add_on_top: "Üste ekle",
    add_below: "Alta ekle",
    add_to_field: "{{fieldName}} alanına ekle",
    value: "Değer",
    key: "Anahtar",
    drag_drop_multiple: "Dosyaları buraya sürükleyin veya seçmek için tıklayın. Sıralamak için sürükleyin.",
    drag_drop_single: "Bir dosyayı buraya sürükleyin veya seçmek için tıklayın",

    open_menu: "Menüyü aç",
    close_drawer: "Menüyü kapat",
    navigation_drawer: "Gezinme menüsü",

    error: "Hata",
    error_uploading_file: "Dosya yükleme hatası",
    error_deleting: "Silme hatası",
    error_before_delete: "Silmeden önce hata",
    error_updating_asset: "Dosya güncelleme hatası",
    error_deleting_asset: "Dosya silme hatası",
    error_firestore_index: "Bu sorgu için bir Firestore index gerekli.",
    create_index: "Index oluştur",
    value_is_not_reference: "Değer bir referans değil.",
    click_to_edit: "Düzenlemek için tıklayın",
    data_is_not_array_of_references: "Veri bir referans dizisi değil",

    loading: "Yükleniyor",
    local_changes_applied: "Yerel değişiklikler forma uygulandı",
    local_changes_discarded: "Yerel değişiklikler atıldı",
    are_you_sure_leave: "Kaydetmeden kapatmak istediğinize emin misiniz?",
    see_console_details: "Ayrıntılar için konsola bakın.",
    drop_here_create_group: "Yeni grup için buraya bırakın",
    filter_for_null_values: "Boş değerleri filtrele",
    value_updated_elsewhere: "Bu değer başka yerde güncellendi",
    add_property: "Alan ekle",
    edit_name: "{{name}} düzenle",
    this_entity_not_exist: "Bu kayıt veritabanında yok",
    internal_error: "İç hata",

    rename_group: "Grubu yeniden adlandır",
    group_name_label: "Grup adı",
    group_name_empty_error: "Grup adı boş olamaz.",
    group_name_exists_error: "Bu grup adı zaten var.",

    search_collections: "Koleksiyonlarda ara",

    views_group: "Görünümler",

    youd_need_to_save_before_additional_collections: "Ek koleksiyon eklemeden önce kaydı kaydedin",

    page_not_found: "Sayfa bulunamadı",
    page_not_found_body: "Bu sayfa yok veya erişim izniniz olmayabilir",
    back_to_home: "Anasayfaya dön",

    default_collection_view: "Varsayılan koleksiyon görünümü",
    table_view: "Tablo",
    cards_view: "Kartlar",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Kayıtların varsayılan nasıl gösterileceğini seçin",

    document_view: "Belge görünümü",
    side_panel: "Yan panel",
    full_screen: "Tam ekran",
    should_documents_opened_full_screen: "Belgeler tam ekran mı yoksa yan panelde mi açılsın",

    select_custom_view: "Özel görünüm seç",
    no_custom_views_defined: "Özel görünüm yok. Bu pencereyi kullanmadan önce özelleştirmede tanımlayın.",

    select_custom_action: "Özel eylem seç",
    no_custom_actions_defined: "Özel eylem yok. Bu pencereyi kullanmadan önce özelleştirmede tanımlayın.",

    no_collections_found: "Koleksiyon bulunamadı",
    start_building_collections: "FireCMS'te koleksiyon oluşturun. Mevcut verilere bağlayın, dosyadan içe aktarın veya şablon kullanın.",
    create_first_collection: "İlk koleksiyonu oluştur",
    define_collections_programmatically: "Koleksiyonları kodla da tanımlayabilirsiniz.",
    edit_collection: "Koleksiyonu düzenle",
    no_permissions_edit_collection: "Bu koleksiyonu düzenleme izniniz yok",
    no_permissions_create_collection: "Koleksiyon oluşturma izniniz yok",
    create_collection: "Koleksiyon oluştur",
    update_collection: "Koleksiyonu güncelle",

    new_collection: "Yeni koleksiyon",
    add_new_collection: "Yeni koleksiyon ekle",
    collection_with_name: "{{name}} koleksiyonu",
    change_icon: "İkonu değiştir",
    is_subcollection_of: "Şunun alt koleksiyonu:",
    name: "Ad",
    collection_name_description: "Koleksiyonun adı, genellikle çoğul (ör. Ürünler)",
    path: "Yol",
    relative_path_to_parent: "Üst koleksiyona göreli yol (üst yolu yazmanıza gerek yok)",
    path_in_database: "Bu koleksiyonun veritabanındaki yolu",
    singular_name: "Tekil ad",
    singular_name_description: "Kayıtlar için isteğe bağlı tekil ad",
    description: "Açıklama",
    description_of_collection: "Koleksiyon açıklaması, markdown kullanabilirsiniz",
    collection_id: "Koleksiyon ID",
    collection_id_description: "Bu koleksiyonu tanımlar. Genelde yol ile aynıdır.",
    collection_group: "Koleksiyon grubu",
    collection_group_description: "Aynı yola sahip tüm koleksiyonlar. Birden fazla koleksiyonu birden sorgular.",
    advanced_settings: "Gelişmiş ayarlar",
    doc_history_global: "Belge geçmişi global açıksa bu koleksiyonda da açık",
    doc_history_enabled: "Belge geçmişi AÇIK",
    doc_history_not_enabled: "Belge geçmişi KAPALI",
    doc_history_description: "Açıkken her belgenin değişiklik geçmişi tutulur. Veri belgenin __history alt koleksiyonundadır.",
    document_id_generation: "Belge ID üretimi",
    code_defined: "Kodda tanımlı",
    users_must_define_id: "Kullanıcılar ID girmeli",
    users_can_define_id: "Kullanıcılar ID girebilir, zorunlu değil",
    doc_id_auto_generated: "Belge ID otomatik üretilir",
    config_doc_id_generation: "Yeni kayıtlarda belge ID'sinin nasıl üretileceğini ayarlayın.",
    enable_text_search: "Bu koleksiyon için metin aramasını aç",
    text_search_description: "Metin aramasına izin ver. Arama delegesi yoksa yerel arama kullanılır. Büyük koleksiyonlarda performans ve maliyet sorunu yaratabilir.",
    database_id: "Veritabanı ID",
    default_text: "(varsayılan)",

    custom_actions: "Özel eylemler",
    more_info: "Daha fazla bilgi",
    define_custom_actions_cli: "Özel eylemleri CLI ile yükleyerek tanımlayın.",
    action_defined_in_code: "Bu eylem kodda şu anahtarla tanımlı",
    add_custom_entity_action: "Özel kayıt eylemi ekle",
    remove_this_action: "Bu eylem kaldırılsın mı?",
    remove_action_warning: "Veri silinmez, yalnızca CMS eylemi kalkar",

    subcollections_of: "Şunun alt koleksiyonları",
    add_subcollection: "Alt koleksiyon ekle",
    custom_views: "Özel görünümler",
    define_custom_views_cli: "Özel görünümleri CLI ile yükleyerek tanımlayın.",
    view_defined_in_code: "Bu görünüm kodda şu anahtarla tanımlı",
    add_custom_entity_view: "Özel kayıt görünümü ekle",
    delete_this_subcollection: "Bu alt koleksiyon silinsin mi?",
    remove_collection_warning: "Veri silinmez, yalnızca CMS koleksiyonu kalkar",
    remove_this_view: "Bu görünüm kaldırılsın mı?",
    remove_view_warning: "Veri silinmez, yalnızca CMS görünümü kalkar",

    no_collection_selected: "Koleksiyon seçilmedi",
    code_for_collection: "Kod:",
    use_config_define_json: "Koleksiyonu JSON olarak tanımlamak için bu yapılandırmayı kullanın.",
    customise_collection_code: "Koleksiyonu kodda özelleştirmek için bu kodu CMS yapılandırmasına ekleyin.",
    copied: "Kopyalandı",

    property_cant_be_edited: "Bu alan düzenlenemez",
    property_not_editable_description: "Düzenleme izniniz olmayabilir veya kodda editable: false tanımlıdır.",
    delete_this_property: "Bu alan silinsin mi?",
    delete_property_warning: "Veri silinmez, yalnızca koleksiyon tanımı değişir.",
    error_must_specify_id: "Alan için bir id belirtmelisiniz",
    error_id_format: "Id yalnızca harf, sayı ve alt çizgi (_) içerebilir; sayı ile başlayamaz",
    error_id_already_exists: "Bu ID'ye sahip başka bir alan var",
    error_must_specify_title: "Alan için bir başlık belirtmelisiniz",
    custom_or_other: "Özel/Diğer",
    select_property_widget: "Alan bileşeni seçin",
    error_changing_data_type: "Bu bileşen başlangıçtakinden farklı veri türü kullanır. Mevcut veride hata olabilir.",
    required: "Zorunlu",

    enum_form_dialog: "Enum formu",
    imported_data_preview: "İçe aktarılan veri önizlemesi",
    entities_with_same_id_overwritten: "Aynı id'ye sahip kayıtların üzerine yazılır",
    collection_editor: "Koleksiyon düzenleyici",
    properties_in_this_group: "Bu gruptaki alanlar",
    data_property_mapping: "Veri-alan eşlemesi",
    property_edit_view: "Alan düzenleme",
    all_of_these: "Tümü",
    any_of_these: "Herhangi biri",

    only_admins_edit_roles: "Rolleri yalnızca yöneticiler düzenleyebilir",
    error_user_not_found: "Kullanıcı bulunamadı",
    role: "Rol",
    name_of_this_role: "Bu rolün adı",
    id_of_this_role: "Bu rolün ID'si",
    create_entities: "Kayıt oluştur",
    read_entities: "Kayıt oku",
    update_entities: "Kayıt güncelle",
    delete_entities: "Kayıt sil",
    all_collections: "Tüm koleksiyonlar",
    create_entities_in_collections: "Koleksiyonlarda kayıt oluştur",
    access_all_data_in_every_collection: "Her koleksiyondaki tüm verilere eriş",
    update_data_in_any_collection: "Herhangi bir koleksiyonda güncelle",
    delete_data_in_any_collection: "Herhangi bir koleksiyonda sil",
    allow_all_permissions_in_this_collections: "Bu koleksiyonlarda tüm izinlere izin ver",
    all: "Tümü",
    customise_permissions_description: "Bu role bağlı kullanıcıların her koleksiyondaki izinlerini özelleştirebilirsiniz",
    create_collections: "Koleksiyon oluştur",
    yes: "Evet",
    no: "Hayır",
    can_user_create_collections: "Kullanıcı koleksiyon oluşturabilir mi",
    edit_collections: "Koleksiyonları düzenle",
    only_own_collections: "Yalnızca kendinin",
    own: "Kendinin",
    can_user_edit_collections: "Kullanıcı koleksiyon düzenleyebilir mi",
    delete_collections: "Koleksiyonları sil",
    can_user_delete_collections: "Kullanıcı koleksiyon silebilir mi",
    error_saving_role: "Rol kaydedilirken hata oluştu",
    create_role: "Rol oluştur",
    update: "Güncelle",

    only_admins_change_roles: "Rolleri yalnızca yöneticiler değiştirebilir",
    must_be_at_least_one_admin: "En az bir yönetici olmalı",
    logged_user_not_found: "Oturum açmış kullanıcı bulunamadı",
    user: "Kullanıcı",
    user_id: "Kullanıcı ID",
    name_of_this_user: "Bu kullanıcının adı",
    email_of_this_user: "Bu kullanıcının e-postası",
    roles: "Roller",
    create_user: "Kullanıcı oluştur",

    users: "Kullanıcılar",
    add_user: "Kullanıcı ekle",
    add_role: "Rol ekle",
    is_admin: "Yönetici",
    default_permissions: "Varsayılan izinler",
    created_on: "Oluşturulma",
    email: "E-posta",
    id: "ID",
    read: "Oku",

    column_in_file: "Dosyadaki sütun",
    map_to_property: "Alana eşle",
    default_values: "Varsayılan değerler",
    default_values_description: "Eşlenmeyen sütunlar ve boş değerler için varsayılan seçebilirsiniz:",
    property: "Alan",
    default_value: "Varsayılan değer",
    autogenerate_id: "ID otomatik üret",
    id_column_description: "Her belgenin ID'si olarak kullanılacak sütun",
    do_not_set_value: "Değer yazma",
    set_value_to_true: "Değeri evet yap",
    set_value_to_false: "Değeri hayır yap",
    drag_and_drop_file: "Dosyayı buraya sürükleyin veya yüklemek için tıklayın",
    error_saving_data: "Veri kaydetme hatası",
    retry: "Yeniden dene",
    saving_data: "Veri kaydediliyor",
    entities_saved: "kayıt kaydedildi",
    do_not_close_tab: "İçe aktarma kesilmesin diye bu sekmeyi kapatmayın",
    import: "İçe aktar",
    import_data: "Veri içe aktar",
    upload_file_description: "CSV, Excel veya JSON yükleyip mevcut şemaya eşleyin",
    back: "Geri",
    next: "İleri",
    save_data: "Veriyi kaydet",
    use_column_as_id: "Bu sütunu ID olarak kullan",
    do_not_import_property: "Bu alanı içe aktarma",
    entities_will_be_overwritten: "Aynı id'ye sahip kayıtların üzerine yazılır",
    data_imported_successfully: "Veri içe aktarıldı",
    export: "Dışa aktar",
    export_data: "Veri dışa aktar",
    download_table_csv: "Bu tablonun içeriğini CSV olarak indir",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Tarihler zaman damgası",
    dates_as_strings: "Tarihler metin",
    flatten_arrays: "Dizileri düzleştir",
    download: "İndir",
    large_number_of_documents: "Bu koleksiyonda çok belge var ({{count}}).",
    include_undefined_values: "Tanımsız değerleri dahil et",
    submit: "Gönder",

    no_filterable_properties: "Filtrelenebilir alan yok",
    apply_filters: "Filtreleri uygula",
    list: "Liste",
    cards: "Kartlar",
    board: "Pano",
    initialize_kanban_order_desc: "Sırası olmayan tüm öğelere ardışık sıra verir. Sütun içi sıra korunur.",
    kanban_view_not_available: "Kanban görünümü kullanılamıyor",
    kanban_view_requires_enum: "Kanban, sütunlar için enum değerli bir metin alanı ister. Şemaya enum alanı ekleyin.",
    no_enum_values_configured: '"{{property}}" alanında enum değeri yok',
    items_need_backfill: "Bazı öğelerde sıra yok. Sürükle-bırak için başlatın.",
    initialize: "Başlat",
    confirm_multiple_delete: "Seçilen kayıtlar silinsin mi?",
    delete_entity_confirm_title: "Bu {{entityName}} silinsin mi?",

    generate_collection_with_ai: "AI ile koleksiyon oluştur",
    modify_collection_with_ai: "AI ile koleksiyonu değiştir",
    describe_collection_to_create: "Oluşturmak istediğiniz koleksiyonu tarif edin.",
    describe_changes_to_make: "Bu koleksiyonda yapmak istediğiniz değişiklikleri tarif edin.",
    ai_placeholder_create: "ör. ad, fiyat, açıklama ve kategori içeren bir ürün koleksiyonu…",
    ai_placeholder_modify: "ör. depolamalı kapak görseli ekle, fiyatı zorunlu yap…",
    ai_assist: "AI yardım",
    generating: "Oluşturuluyor...",

    this_is_subcollection_of: "Şunun alt koleksiyonu:",
    use_existing_paths_database: "Veritabanındaki mevcut yollardan birini kullanın:",
    describe_collection_ai: "Koleksiyonunuzu AI'ya tarif edin:",
    generate_with_ai: "AI ile oluştur",
    create_from_json_config: "JSON yapılandırmasından oluştur:",
    paste_json_config: "JSON yapılandırmasını yapıştır",
    create_collection_from_file_formats: "Dosyadan koleksiyon oluştur (csv, json, xls, xlsx…)",
    select_template: "Şablon seçin:",
    products: "Ürünler",
    collection_products_subtitle: "Görsel, fiyat ve stok içeren ürün koleksiyonu",
    collection_users_subtitle: "E-posta, ad ve rol içeren kullanıcı koleksiyonu",
    blog_posts: "Blog yazıları",
    collection_blog_posts_subtitle: "Görsel, yazar ve zengin içerikli blog yazıları",
    pages: "Sayfalar",
    collection_pages_subtitle: "Görsel, yazar ve zengin içerikli sayfalar",
    continue_from_scratch: "Sıfırdan devam et",

    cms_users: "CMS kullanıcıları",
    roles_menu: "Roller",
    project_settings: "Proje ayarları",
    firestore_manager: "Firestore yöneticisi",
    manage_your_firestore_data: "Firestore verinizi yönetin",

    build_admin_panel_in_minutes: "Firebase yönetim panelinizi dakikalar içinde kurun",
    go_live_instantly: "Hemen yayına alın:",
    create_production_ready_back_offices: "Üretime hazır arka ofisler oluşturun",
    without_the_frontend_hassle: "ön yüz derdi olmadan.",
    automatic_setup: "Otomatik kurulum",
    from_your_existing_firestore_data: "mevcut Firestore verinizden.",
    seamless_real_time_firebase_integration: "Kesintisiz gerçek zamanlı Firebase entegrasyonu.",
    intuitive_spreadsheet_like_ui: "Tablo benzeri arayüz",
    your_whole_team_can_use: "tüm ekibiniz kullanabilir.",
    focus_on_your_app: "Uygulamanıza odaklanın,",
    not_the_admin_panel: "yönetim paneline değil.",
    join_our_newsletter: "Bültene katılın. Spam yok, yalnızca önemli güncellemeler.",
    by_signing_in_you_agree_to_our: "Giriş yaparak şunları kabul edersiniz:",
    terms_and_conditions: "Şartlar ve Koşullar",
    and_our: "ve",
    privacy_policy: "Gizlilik politikası",
    firecms_cloud_google_disclosure: "FireCMS Cloud'un Google API'lerinden aldığı bilgileri kullanması ve aktarması şuna uyar:",
    google_api_services_user_data_policy: "Google API Hizmetleri Kullanıcı Verisi Politikası",
    including_the_limited_use_requirements: "sınırlı kullanım şartları dahil.",
    email_password: "E-posta/şifre",
    sign_in_with_google: "Google ile giriş yap",

    auth_user_not_found: "Kullanıcı bulunamadı",
    auth_wrong_password: "Şifre yanlış. Tekrar deneyin.",
    auth_user_disabled: "Kullanıcı devre dışı. Destek ile iletişime geçin.",
    auth_account_exists_with_different_credential: "Hesap farklı bir giriş yöntemiyle kayıtlı",
    auth_email_already_in_use: "Bu e-posta zaten kullanılıyor",
    auth_google_permissions_required: "Google Cloud projelerini yönetmek için ek izin vermelisiniz",
    auth_invalid_email_password: "E-posta ve şifreyi girin",
    auth_enter_email_first: "Önce e-postanızı girin",
    auth_password_reset_sent: "Şifre sıfırlama e-postası gönderildi",
    auth_sign_in_account: "Hesabınıza giriş yapın",
    auth_create_new_account: "Yeni hesap oluştur",
    auth_password: "Şifre",
    auth_reset_password: "Şifreyi sıfırla",
    auth_new_user: "Yeni kullanıcı?",
    auth_have_account: "Hesabınız var mı?",
    auth_sign_in: "Giriş",
    auth_sign_up: "Kayıt ol",

    subscriptions: "Abonelikler",
    manage_your_subscriptions_in_stripe: "Aboneliklerinizi Stripe'ta yönetin",
    go_to_your_stripe_portal: "Fatura geçmişi için Stripe portalına gidin. Oturum açmış kullanıcının aboneliklerini de yönetebilirsiniz.",
    your_pro_licenses: "PRO lisanslarınız",
    create_new_license: "Yeni lisans oluştur",
    create_subscriptions_in_this_section: "Bu bölüm yalnızca kendi barındırdığınız FireCMS PRO içindir. FireCMS Cloud kullanıyorsanız projeyi ayarlardan yükseltin.",
    if_you_are_an_agency: "Ajanssanız lisansınızı müşterilerinize satabilirsiniz.",
    if_you_have_any_questions: "Sorunuz varsa bize yazın:",
    you_have_not_created_any_pro_licenses: "Henüz FireCMS PRO lisansı oluşturmadınız",
    archive: "Arşivle",
    licensed_projects_lowercase: "lisanslı proje",
    manage: "Yönet",
    update_payment_method: "Ödeme yöntemini güncelle",
    your_firecms_cloud_projects: "FireCMS Cloud projeleriniz",
    status_active: "Aktif",
    status_trialing: "Deneme",
    status_past_due: "Gecikmiş",
    status_canceled: "İptal",
    status_unpaid: "Ödenmedi",
    status_incomplete: "Eksik",
    status_incomplete_expired: "Eksik ve süresi doldu",
    status_unknown: "Bilinmiyor",

    plan_free: "Abone değil",
    plan_cloud_plus: "Abone",
    plan_pro: "Pro",
    plan_unknown: "Bilinmeyen plan",

    auto_setup_collections_button: "Koleksiyonları otomatik kur",
    auto_setup_collections_title: "Koleksiyonlar otomatik kurulsun mu?",
    auto_setup_collections_desc: "Henüz eşlenmemiş koleksiyonlar için yapılandırma oluşturulur",
    setting_up_collections: "Koleksiyonlar kuruluyor",
    setting_up_collection: "{{name}} kuruluyor",
    no_collections_found_to_setup: "Kurulacak koleksiyon yok.",
    collections_have_been_setup: "Koleksiyonlar otomatik kuruldu.",
    error_setting_up_collections: "Koleksiyonlar kurulurken hata",
    setup_collections_title: "Koleksiyonları kur",
    setup_collections_select_desc: "Otomatik kurulacak koleksiyonları seçin:",
    select_all: "Tümünü seç",
    deselect_all: "Seçimi kaldır",
    setup_collections_confirm: "Kur ({{count}})",
    collection_setup_success: "{{name}} kuruldu",
    go_to_collection: "Koleksiyona git",

    add_your: "Ekleyin:",
    database_collections: "veritabanı koleksiyonları",
    to_firecms: "FireCMS'e",
    no_unmapped_collections: "Veritabanında eşlenmemiş koleksiyon yok",
    query_and_update_with_datatalk: "Verinizi doğal dille sorgulayın ve güncelleyin:",

    welcome_to_firecms: "FireCMS Cloud'a hoş geldiniz",
    admin_panel_ready_bring_data: "Yönetim paneliniz hazır. Verinizi getirelim.",
    admin_panel_ready_get_started: "Yönetim paneliniz hazır. Başlamak için:",
    auto_detect_collections: "Koleksiyonları otomatik bul",
    auto_detect_collections_desc: "AI veritabanını tarayıp koleksiyon şeması üretir.",
    create_a_collection: "Koleksiyon oluştur",
    create_collection_desc: "İlk koleksiyonu görsel düzenleyiciyle sıfırdan tanımlayın.",
    read_the_docs: "Dokümantasyonu oku",
    read_the_docs_desc: "Alan, görünüm, eylem ve daha fazlasını özelleştirmeyi öğrenin.",
    explore_docs: "Dokümantasyonu incele",
    want_to_customize_with_code: "Kodla özelleştirmek ister misiniz? Çalıştırın:",
    to_scaffold_a_local_project: "yerel proje iskeleti için.",

    validation: "Doğrulama",
    unique: "Benzersiz",
    required_message: "Zorunlu mesajı",
    required_tooltip: "Bu değer yoksa kayıt kaydedilemez",
    unique_tooltip: "Aynı değere sahip birden fazla kayıt olamaz",
    lowercase: "Küçük harf",
    uppercase: "Büyük harf",
    trim: "Boşlukları kırp",
    exact_length: "Tam uzunluk",
    min_length: "En az uzunluk",
    max_length: "En fazla uzunluk",
    matches_regex: "Regex ile eşleşir",
    not_valid_regexp: "Geçerli regex değil",
    regex_helper: "ör. yalnızca rakam için /^\\d+$/",
    min_value: "En küçük değer",
    max_value: "En büyük değer",
    less_than: "Şundan küçük",
    more_than: "Şundan büyük",
    positive_value: "Pozitif değer",
    negative_value: "Negatif değer",
    integer_value: "Tam sayı",

    invalid_regular_expression: "Geçersiz düzenli ifade",
    must_specify_target_collection: "Alan için hedef koleksiyon belirtmelisiniz",
    need_specify_repeat_field: "Tekrar alanını belirtmelisiniz",
    need_specify_block_properties: "Bu bloğun alanlarını belirtmelisiniz",
    incomplete_condition: "Eksik koşul — bir alan seçin",
    field_name: "Alan adı",

    kanban_column_property: "Kanban sütun alanı",
    select_a_property: "Alan seçin",
    kanban_property_not_found: "\"{{property}}\" yok veya enum metin alanı değil. Geçerli bir alan seçin veya temizleyin.",
    no_enum_string_properties: "Enum metin alanı yok. Kanban için enumValues olan bir metin alanı ekleyin.",
    kanban_column_description: "Sütunlar için enum değerli bir metin alanı seçin",
    create_property: "+ \"{{property}}\" alanı oluştur",
    order_property: "Sıra alanı",
    order_property_not_found: "\"{{property}}\" yok veya sayı alanı değil. Geçerli bir alan seçin veya temizleyin.",
    no_number_properties: "Sayı alanı yok. Sıralama için bir sayı alanı ekleyin.",
    order_property_description: "Öğe sırasını tutacak sayı alanını seçin",
    display_settings: "Görünüm ayarları",
    default_row_size: "Varsayılan satır boyutu",
    side_dialog_width: "Yan panel genişliği",
    side_dialog_width_description: "Kayıt yan panelinin piksel genişliği. Varsayılan 768px",
    inline_editing_enabled: "Veri tabloda doğrudan düzenlenebilir",
    inline_editing_disabled: "Veri yalnızca formda düzenlenebilir",
    inline_editing_description: "Formu açmadan tabloda düzenlemeye izin ver.",
    include_json_view: "JSON görünümünü dahil et",
    no_json_view: "JSON görünümü olmasın",
    json_view_description: "Belgenin JSON gösterimini dahil et.",
    not_found_suffix: "bulunamadı",

    editor_text: "Metin",
    editor_text_description: "Düz metin yazmaya başlayın.",
    editor_heading_1: "Başlık 1",
    editor_heading_1_description: "Büyük bölüm başlığı.",
    editor_heading_2: "Başlık 2",
    editor_heading_2_description: "Orta bölüm başlığı.",
    editor_heading_3: "Başlık 3",
    editor_heading_3_description: "Küçük bölüm başlığı.",
    editor_todo_list: "Yapılacaklar",
    editor_todo_list_description: "Görevleri listeleyin.",
    editor_bullet_list: "Madde işaretli liste",
    editor_bullet_list_description: "Basit madde listesi.",
    editor_numbered_list: "Numaralı liste",
    editor_numbered_list_description: "Numaralı liste.",
    editor_quote: "Alıntı",
    editor_quote_description: "Alıntı ekleyin.",
    editor_code: "Kod",
    editor_code_description: "Kod parçası ekleyin.",
    editor_image: "Görsel",
    editor_image_description: "Bilgisayardan görsel yükleyin.",
    editor_multiple: "Birden fazla",
    editor_link: "Bağlantı",
    editor_save: "Kaydet",
    editor_cancel: "Vazgeç",
    editor_remove_link: "Bağlantıyı kaldır",
    editor_paste_or_type_link: "Bağlantıyı yapıştırın veya yazın",
    editor_open_in_new_window: "Yeni pencerede aç",
    editor_bold: "Kalın",
    editor_italic: "İtalik",
    editor_underline: "Altı çizili",
    editor_strikethrough: "Üstü çizili",
    editor_autocomplete: "Otomatik tamamla",
    editor_autocomplete_description: "Bağlama göre metin ekle.",

    text_search_dialog_title: "Metin aramasını aç",
    text_search_local_not_recommended: "Yerel metin araması büyük koleksiyonlar için önerilmez.",
    text_search_local_fetch_warning: "Yerel arama tüm belgeleri çekip tarayıcıda tutar. Büyük koleksiyonlarda yavaş ve maliyetli olabilir.",
    text_search_external_suggestion: "Büyük koleksiyonlarda Algolia veya Elastic Search gibi harici arama ve bir arama delegesi kullanın.",
    text_search_local_description: "Yerel arama en basit yoldur. Tüm belgeleri tarayıcıya yükleyip yerelde arar. Küçük koleksiyonlar için uygundur.",
    text_search_own_implementation: "Kendi metin arama denetleyicinizi yazdınız. Koleksiyon için aramayı açabilirsiniz.",
    text_search_enable_for_collection: "Bu koleksiyon için aç",
    text_search_enable_for_project: "Proje için aç",
    text_search_enabled_snackbar: "Yerel metin araması açıldı",

    settings_subscription_plan: "Abonelik planı",
    settings_subscribed_to: "Şu plana abonesiniz:",
    settings_no_active_subscription: "Bu proje için aktif abonelik yok.",
    settings_trial_valid_until: "Denemeniz {{date}} tarihine kadar geçerli.",
    settings_features_intro: "FireCMS Cloud ile kullandığınız özelliklerden bazıları",
    settings_feature_managed_service: "Yönetilen, güncel servis",
    settings_feature_local_text_search: "Yerel metin araması",
    settings_feature_unlimited_users_roles: "Sınırsız kullanıcı ve rol",
    settings_feature_theme_logo: "Tema ve logo özelleştirme",
    settings_feature_custom_fields_views: "Özel form alanları ve görünümler",
    settings_feature_secondary_databases: "İkincil veritabanları",
    settings_feature_ai_content: "OpenAI ve Google ile AI içerik",
    settings_feature_unlimited_export: "Sınırsız dışa aktarma",
    settings_feature_appcheck: "AppCheck",
    settings_heading: "Ayarlar",
    settings_project_name: "Proje adı",
    settings_default_language: "Varsayılan dil",
    settings_default_language_caption: "Projenin temel dilini seçin. Kullanıcılar kendi ayarlarından değiştirebilir.",
    settings_enable_local_text_search: "Yerel metin aramasını aç",
    settings_local_text_search_caption: "Tüm koleksiyonlarda yerel metin araması. FireCMS arama çubuğu metin alanlarını tarar. Tüm metin alanları indekslendiği için okuma sayısı artabilir.",
    settings_doc_history_all_collections: "Tüm koleksiyonlarda belge geçmişi",
    settings_doc_history_caption: "Açıksa koleksiyonlar varsayılan geçmiş tutar. Koleksiyon bazında kapatılabilir. Geçmiş belgenin __history alt koleksiyonundadır.",
    settings_theme: "Tema",
    settings_primary_color: "Ana renk",
    settings_secondary_color: "İkincil renk",
    settings_sample_theme_components: "Örnek tema bileşenleri",
    settings_drag_drop_logo: "Logonuzu buraya sürükleyin",
    settings_create_subscription: "Abonelik oluştur",
    settings_stripe_disclaimer: "Aboneliği tamamlamak için Stripe'a yönlendirilirsiniz. Faturalama aylık, o ayki en yüksek kullanıcı sayısına göredir. İstediğiniz zaman iptal edin — içinde bulunduğunuz dönem ödenmiştir.",
    settings_subscription_is: "Abonelik",
    settings_next_payment_on: "Sonraki ödeme: {{date}}.",
    settings_seats_count: "Toplam",
    settings_seat: "koltuk",
    settings_seats: "koltuk",
    settings_per_seat: "{{price}}/koltuk/{{interval}}",
    settings_current_price: "Güncel fiyat",
    settings_per_user_usage: "kullanıcı başı (kullanıma göre).",
    settings_cancelled_active_until: "Bu abonelik iptal edildi ve {{date}} tarihine kadar aktif kalır.",
    settings_no_additional_charges: "İptalden sonra ek ücret olmaz.",
    settings_manage_subscription: "Aboneliği yönet",
    settings_security_rules: "Güvenlik kuralları",
    settings_security_rules_description: "FireCMS, veri erişimini Firebase kurallarıyla kısıtlar. Yeni kullanıcıda fireCMSUser özel claim eklenir. Aşağıdaki kurallarla FireCMS kullanıcıları panele erişir.",
    settings_security_rules_add_domain: "{{domain}} alanını sağlayıcının izinli domain listesine ekleyin",
    settings_security_rules_caption: "Bu kurallar veriyi FireCMS kullanıcılarıyla sınırlar; izinleri veritabanı düzeyinde eşlemez. İzinler ön yüzde uygulanır. Veritabanı düzeyinde istiyorsanız kuralları kendiniz düzenleyin. Roller Firebase token'da custom claim olarak durur.",
    settings_appcheck: "AppCheck",
    settings_appcheck_description: "Firebase servislerini kötüye kullanıma karşı AppCheck ile koruyabilirsiniz. Firebase dokümantasyonundan kurun. Sağlayıcı hazırsa burada açın. Firebase ayarlarında secret, FireCMS'te site key gerekir.",
    settings_appcheck_add_domain: "{{domain}} alanını sağlayıcının izinli domain listesine ekleyin",
    settings_appcheck_enable: "AppCheck'i aç",
    settings_appcheck_site_key: "Site anahtarı",
    settings_appcheck_update: "AppCheck'i güncelle",
    settings_appcheck_refresh_note: "Kayıttan sonra değişiklikleri görmek için sayfayı yenilemeniz gerekebilir.",
    settings_appcheck_updated: "AppCheck güncellendi",
    settings_appcheck_error: "AppCheck güncellenirken hata",

    missing_firestore_security_rules: "Firestore güvenlik kuralları eksik",
    firecms_cloud_requires_security_rule: "FireCMS Cloud, kimliği doğrulanmış kullanıcılara erişim için belirli bir Firestore kuralı ister. Koleksiyon",
    cannot_be_accessed_without_it: "bu kural olmadan okunamaz.",
    required_security_rule: "Gerekli güvenlik kuralı",
    fix_automatically: "Otomatik düzelt",
    open_firebase_rules: "Firebase kurallarını aç",
    security_rules_updated_successfully: "Güvenlik kuralları güncellendi. Veriyi yüklemek için sayfayı yenileyin.",
    sec_rules_fixing: "Düzeltiliyor...",
    sec_rules_fixed: "Düzeltildi!",

    marketplace_managed_by_gcp: "GCP Marketplace üzerinden yönetilir",
    marketplace_billing_note: "Aboneliğiniz Google Cloud Marketplace üzerinden yönetilir. Plan, fatura ve iptal GCP Console'dadır.",
    marketplace_manage_in_gcp_console: "GCP Console'da yönet",
    marketplace_plan_changes_note: "Plan değiştirmek veya iptal için GCP Marketplace siparişlerinize gidin.",
    marketplace_welcome_title: "GCP Marketplace'ten hoş geldiniz!",
    marketplace_welcome_subtitle: "Google Cloud Marketplace aboneliğiniz aktif. Bağlamak için mevcut bir proje seçin veya yeni oluşturun.",
    marketplace_select_or_create_project: "Proje seçin veya oluşturun",
    marketplace_link_project: "Projeyi bağla",
    marketplace_linking: "Proje bağlanıyor…",
    marketplace_link_success: "Proje bağlandı! Yönlendiriliyor…",
    marketplace_link_error: "Proje bağlanırken hata. Tekrar deneyin.",
    marketplace_no_account_id: "GCP Marketplace hesap ID'si yok. GCP Marketplace'ten başlayın.",
};
